<template>
  <div>
    <va-card :title="$t('menu.queues')">
      <div class="row">
        <va-list fit class="flex xs6 md6" v-for="queue in queues" :key="queue.name">
          <va-list-label color="secondary">
            {{ queue.name }}
          </va-list-label>
            
          <template v-if="queue.itens.length">
            <div v-for="(item, index) in queue.itens" :key="item.id">
              <va-item>
                <va-item-section>
                  <va-item-label>
                    {{ `#${index + 1}  ${item.user}` }}
                  </va-item-label>
                </va-item-section>

                <va-button
                small 
                inline 
                color="danger" 
                icon="fa fa-remove"
                class="ma-1" 
                @click="remove(queue.queue_name, item.id)"
                >
                  {{ $t('tables.delete') }}
                </va-button>

                
              </va-item>
              <va-separator/>
            </div>

              <div class="flex xs6 md6">
                <va-button
                  small 
                  inline 
                  color="danger" 
                  icon="fa fa-remove"
                  class="ma-1" 
                  @click="removeAll(queue.queue_name)"
                  >
                    {{ $t('tables.deleteAll') }}
                </va-button>
              </div>
          </template>

          <template v-else >
            <va-item>
              <va-item-section>
                <va-item-label :style="{color: $themes.secondary}">
                  {{ $t('tables.empty') }}
                </va-item-label>
              </va-item-section>
            </va-item>
          </template>
        </va-list>
      </div>
    </va-card>
  </div>
</template>

<script>
import { http } from "@/services/config"
import { showError } from '@/global'
import { mapState } from "vuex";
import { unix } from 'moment';

export default {
  data() {
    return {
      queues: [],
      fields: [
        { name: "position", title: "Posição" },
        { name: "user", title: "Usuário" },
      ]
    };
  },

  channels: {
    NeedRefreshQueues: {
      received(data) {
        this.getQueues()
      },
    }
  },

  mounted() {
    this.getQueues()
    this.$cable.subscribe({ channel: 'NeedRefreshQueues', company: this.currentUser.company })
  },

  computed: {
    ...mapState(['currentUser', 'currentLocality']),
  },

  watch: {
    '$store.state.currentLocality': function() {
      this.getQueues()
    }
  },

  methods: {
    async getQueues() {
      await http.get(`order/request_queues?locality_id=${this.currentLocality.id}`).then(res => {
        this.queues = res.data["queues"]
      }).catch(e =>{
        showError(e)
      })
    },

    remove(queue, item) {
      http.post("/order/remove_from_queue", {
        "queue": queue,
	      "item": item,
        "locality_id": this.currentLocality.id
      }).then(res => {
        this.getQueues()
      }).catch(e =>{
        showError(e)
      })
    },

    removeAll(queue){
      let count = 0
      let itens = []
      let queue_name = ''

      if (queue == queue) {
        if (this.queues[0].itens.length > 0) {
          count = this.queues[0].itens.length;
          itens = this.queues[0].itens;
          queue_name = this.queues[0].queue_name;
        
          for (const item in itens) {
            this.remove(queue_name, itens[item].id)
          }
        } 
      }

      if (queue == queue) {
        if (this.queues[1].itens.length > 0) {
          count = this.queues[1].itens.length;
          itens = this.queues[1].itens;
          queue_name = this.queues[1].queue_name;
        
          for (const item in itens) {
            this.remove(queue_name, itens[item].id)
          }
        }
      }
    }
  }
};
</script>
